import { render, staticRenderFns } from "./HistoryOrderTimeline.vue?vue&type=template&id=2b3a260c"
import script from "./HistoryOrderTimeline.vue?vue&type=script&lang=js"
export * from "./HistoryOrderTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports